export default __webpack_public_path__ + "static/media/38.e0716db9.png";